import $ from "jquery";
import { areas } from "../framework/areas";
import { countryState } from "./countryState";
import { dateFormatter } from "../framework/dateFormatter";
import { regions } from "../framework/regions";
import { services } from "../services/notificationService";
import { dataaccess } from "../dataaccess/dataContext";

let sortColumn;
let sortColumnIndex;
let sortOrder;
let courseSearchFilters;
let coursesTable; //putting this here so I have a reference. Otherwise calling Datatable() seems to recreate it?

function init() {
    sortColumn = "";
    sortColumnIndex = 0;
    sortOrder = false;

    dateFormatter.initDatePicker();
}

function doSetup() {
    return $.Deferred(function(def) {
        const regionPromise = populateRegions();
        const areaPromise = populateAreas();
        const countryPromise = countryState.populateCountriesSelect("#searchCountrySelect", "#searchNaStateSelection");

        $.when(regionPromise, areaPromise, countryPromise).then(function() {
            // Load SearchFilters initially from sessionStorage and set the fields
            // If there weren't any filters in session then create new one
            // Do it after all the selects have been populated
            if (typeof (Storage) !== "undefined" && sessionStorage.getItem("courseSearchFilters") !== null) {
                courseSearchFilters = JSON.parse(sessionStorage.getItem("courseSearchFilters"));
            } else {
                setFilters();
            }
            setFieldsToFilter(courseSearchFilters);
            setEvents();
            populateAreasBySelectedRegion();
            def.resolve();
        }).fail(function() {
            services.notificationService.error("An unexpected error has occurred. Please try again later.");
        });
    }).fail(function() {
        services.notificationService.error("An unexpected error has occurred. Please try again later.");
    });
}

function setEvents() {
    $("#searchCountrySelect").change(function() {
        const selectedCountry = $(this).val();
        countryState.populateStatesSelect("#searchNaStateSelection", "", selectedCountry);
    });

    $("#searchRegionSelect").change(function() {
        populateAreasBySelectedRegion();
    });

    $("#searchCourseTypeSelect").change(function () {
        populateCourseLengthBySelectedCourseType();
    });
}

function populateCourseLengthBySelectedCourseType() {
    const courseTypeId = $("#searchCourseTypeSelect").val();
    dataaccess.get({ url: "/Course/GetCourseLengths/" + courseTypeId }).done(function (results) {
        initsearchCourseLengthSelect();
        let i;
        for (i = 0; i < results.length; i++) {
            $("#searchCourseLengthSelect").append(
                "<option value=" +
                results[i].id +
                " data-schedule-days='" +
                results[i].scheduleDays +
                "'>" +
                results[i].description +
                "</option>"
            );
        }
    });
}
function initsearchCourseLengthSelect() {
    $("#searchCourseLengthSelect")
        .find("option")
        .remove()
        .end()
        .append(
            $("<option />")
                .val("")
                .text("Select One")
        );
}

function populateAreasBySelectedRegion() {
    const selectedRegionId = $("#searchRegionSelect").val();

    if (selectedRegionId === "") {
        $("#searchRegionAreaSelect option").show();
    } else {
        $("#searchRegionAreaSelect option").not(":first").hide();
        $("#searchRegionAreaSelect option[data-region='" + selectedRegionId + "']").show();
    }
}

function getFilters() {
    return courseSearchFilters;
}

function setFilters() {
    let commercialSupport;
    const commercialSupportYes = $("#csYes").is(":checked");
    const commercialSupportNo = $("#csNo").is(":checked");

    if (commercialSupportYes || commercialSupportNo) {
        if (commercialSupportYes) {
            commercialSupport = $("#csYes").is(":checked");
        } else {
            commercialSupport = false;
        }
    } else {
        commercialSupport = null;
    }

    const searchFilter = {
        specialSituation: $("#SpecialSituation").is(":checked"),
        closed: $("#searchClosed").is(":checked"),
        commercialSupport: commercialSupport,
        countryId: $("#searchCountrySelect").find("option:selected").attr("countryId"), // Used by search filter in program
        countryValue: $("#searchCountrySelect").val(), // Used by filters to set selected country
        courseStatusId: $("#SearchCourseStatusSelect").val(),
        courseTypeId: $("#searchCourseTypeSelect").val(),
        desc: sortOrder,
        endDate: $("#dateRangeEnd").val(),
        keyword: $("#searchKeyword").val(),
        open: $("#searchOpen").is(":checked"),
        programIds: [],
        regionAreaId: $("#searchRegionAreaSelect").val(),
        regionId: $("#searchRegionSelect").val(),
        sortColumn: sortColumn,
        sortColumnIndex: sortColumnIndex,
        startDate: $("#dateRangeStart").val(),
        stateId: $("#searchStateSelect").val(),
        courseLengthId: $("#searchCourseLengthSelect").val()
    };

    courseSearchFilters = searchFilter;
    putFilterInStorage();

    return courseSearchFilters;
}

function putFilterInStorage() {
    if (typeof (Storage) !== "undefined") {
        sessionStorage.setItem("courseSearchFilters", JSON.stringify(courseSearchFilters));
    }
}

function setFieldsToFilter(filters) {
    $("#searchKeyword").val(filters.keyword);
    $("#searchOpen").prop("checked", filters.open === true);
    $("#searchClosed").prop("checked", filters.closed === true);
    if (filters.commercialSupport !== null) {
        if (filters.commercialSupport) {
            $("#csYes").prop("checked", true);
        } else {
            $("#csNo").prop("checked", true);
        }
    }
    if (filters.specialSituation !== null) {
        if (filters.specialSituation) {
            $("#SpecialSituation").prop("checked", true);
        }
    }
    $("#dateRangeStart").val(filters.startDate);
    $("#dateRangeEnd").val(filters.endDate);
    $("#searchRegionSelect").val(filters.regionId);
    $("#searchCountrySelect").val(filters.countryValue);
    countryState.populateStatesSelect("#searchNaStateSelection", "", filters.countryValue);
    $("#searchStateSelect").val(filters.stateId);
    $("#searchRegionAreaSelect").val(filters.regionAreaId);
    $("#SearchCourseStatusSelect").val(filters.courseStatusId);
    $("#searchCourseTypeSelect").val(filters.courseTypeId);
    $("#searchCourseLengthSelect").val(filters.courseLengthId);

    sortColumn = filters.sortColumn;
    sortColumnIndex = filters.sortColumnIndex;
    sortOrder = filters.desc;
    setSortOrder(sortColumn, sortColumnIndex, sortOrder);
}

function setSortOrder(sortColumn, sortColumnIndex, sortOrder) {
    if (sortColumn !== "undefined" && sortColumn !== "") {
        return;
    }
    if (typeof coursesTable === "undefined") {
        return;
    }
    if (sortColumn !== null && sortColumnIndex > 0) {
        if (sortOrder) {
            coursesTable.columns[sortColumnIndex].addClass("sorting_desc");
        } else {
            coursesTable.columns[sortColumnIndex].addClass("sorting_asc");
        }
    }
}

function getQueryStringFilters() {
    const filters = getFilters();
    for (const key in filters) {
        if (!filters[key]) {
            delete filters[key];
        }
    }
    return filters;
}

function clearFilters() {
    $("#searchKeyword").val("");
    $("#searchFilters :input").each(function() {
        switch (this.type) {
            case "text":
                $("#searchKeyword, #dateRangeStart, #dateRangeEnd").val("");
                break;
            case "textarea":
                $(this).val("");
                break;
            case "checkbox":
                $(this).prop("checked", false);
                $("#searchOpen").prop("checked", true);
                $("#searchClosed").prop("checked", false);
                $("#SpecialSituation").prop("checked", false);
                break;
            case "radio":
                this.checked = false;
                break;
        }
    });

    $("#searchRegionSelect, #searchRegionAreaSelect, #searchCountrySelect, #searchStateSelect, #SearchCourseStatusSelect, #searchCourseTypeSelect").find("option:selected").prop("selected", false);
    $("#searchStateSelect")
        .find("option")
        .remove()
        .end()
        .append("<option value=\"\">State/Province</option>");

    setFilters();
    putFilterInStorage();
}

function setSort(paramSortColumn, paramSortColumnIndex, paramSortOrder) {
    courseSearchFilters.sortColumn = paramSortColumn;
    courseSearchFilters.sortColumnIndex = paramSortColumnIndex;
    courseSearchFilters.desc = paramSortOrder;
    putFilterInStorage();
}

function setCoursesTable(paramCoursesTable) {
    coursesTable = paramCoursesTable;
}

function populateRegions() {
    return regions.getRegions().done(function (results) {
        const selectList = $("#searchRegionSelect");
        selectList.find("option").not(":first").remove();
        for (let i = 0; i < results.length; i++) {
            $("#searchRegionSelect")
                .append("<option value='" + results[i].id + "'>" + results[i].regionNumber + "</option>");
        }
    });
}

function populateAreas() {
    areas.getAreas().done(function (results) {
        const selectList = $("#searchRegionAreaSelect");
        selectList.find("option").not(":first").remove();
        for (let i = 0; i < results.length; i++) {
            let name = results[i].name;
            name = name.replace("(assigned)", "");
            $("#searchRegionAreaSelect").append("<option data-region='" + results[i].regionId + "' value='" + results[i].id + "'>" + name + "</option>");
        }
    });
}
export const courseDashboardFilters = {
    init: init,
    getFilters: getFilters,
    setFilters: setFilters,
    clearFilters: clearFilters,
    getQueryStringFilters: getQueryStringFilters,
    setSort: setSort,
    setCoursesTable: setCoursesTable,
    doSetup: doSetup
};